/*
* Login Page
* @author: Abdo Hamoud (TRX Solutions)
*/

import {createApp} from 'vue';
import Login from './components/Login.vue';

if (document.getElementById('minierp-login')) {
    const app = createApp(Login);
    app.mount('#minierp-login');
}
